{
  "name": "@e2b/cli",
  "version": "1.5.0",
  "description": "CLI for managing e2b sandbox templates",
  "homepage": "https://e2b.dev",
  "license": "MIT",
  "author": {
    "name": "FoundryLabs, Inc.",
    "email": "hello@e2b.dev",
    "url": "https://e2b.dev"
  },
  "bugs": "https://github.com/e2b-dev/e2b/issues",
  "repository": {
    "type": "git",
    "url": "https://github.com/e2b-dev/e2b",
    "directory": "packages/cli"
  },
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "e2b",
    "ai-agents",
    "agents",
    "ai",
    "code-interpreter",
    "sandbox",
    "code",
    "cli",
    "runtime",
    "vm",
    "nodejs",
    "javascript",
    "typescript"
  ],
  "sideEffects": false,
  "scripts": {
    "prepublishOnly": "pnpm build",
    "build": "tsc --noEmit --skipLibCheck && tsup --minify",
    "dev": "tsup --watch",
    "lint": "eslint src",
    "test": "pnpm build && cd testground/demo-basic && ../../dist/index.js template build",
    "check-deps": "knip",
    "update-deps": "ncu -u && pnpm i",
    "generate-ref": "./scripts/generate_sdk_ref.sh"
  },
  "devDependencies": {
    "@types/command-exists": "^1.2.3",
    "@types/inquirer": "^9.0.7",
    "@types/json2md": "^1.5.4",
    "@types/node": "^18.18.6",
    "@types/statuses": "^2.0.5",
    "@types/update-notifier": "6.0.5",
    "json2md": "^2.0.1",
    "knip": "^5.43.6",
    "npm-check-updates": "^16.14.6",
    "tsup": "^8.4.0",
    "typescript": "^5.2.2"
  },
  "files": [
    "dist",
    "LICENSE",
    "README",
    "package.json"
  ],
  "bin": {
    "e2b": "dist/index.js"
  },
  "dependencies": {
    "@iarna/toml": "^2.2.5",
    "async-listen": "^3.0.1",
    "boxen": "^7.1.1",
    "chalk": "^5.3.0",
    "cli-highlight": "^2.1.11",
    "command-exists": "^1.2.9",
    "commander": "^11.1.0",
    "console-table-printer": "^2.11.2",
    "e2b": "^1.5.2",
    "inquirer": "^9.2.12",
    "open": "^9.1.0",
    "statuses": "^2.0.1",
    "strip-ansi": "^7.1.0",
    "update-notifier": "^6.0.2",
    "yup": "^1.3.2"
  },
  "engines": {
    "node": ">=18"
  }
}
